import PriceTable from "entities/price-table";
import ProductsTotal from "entities/products-total";
import Card from "shared/ui/card";
import { concatClassnames } from "shared/utils/concatClassnames";
import { useCartContext } from "app/providers/CartProvider";
import ProductItemExtra from "entities/product-item-extra";
import SidebarProductsList from "widgets/shared/sidebar-products-list";
import CheckoutPanelList from "../standard-product-list";
import CheckoutSidebarPanelList from "../sidebar-panel-list";
import StandardProductPriceTable from "entities/configurator/standard-product-price-table";
import SampleSaleDoorPriceTable from "entities/configurator/sample-sale-door-price-table";
import classNames from "classnames";

interface CheckoutSidebarProductsProps {
  className?: string;
}

const CheckoutSidebarProducts = ({
  className = "",
}: CheckoutSidebarProductsProps) => {
  const cartContext = useCartContext();
  const cart = useCartContext().getCart();
  const isSampleSale = cartContext.isSampleSale;

  return (
    <section className={concatClassnames("gg-grid", className)}>
      <div className="gg-rounded-sm gg-bg-grey-500">
        {cart.products.length ? (
          <div className="gg-px-5 gg-pb-7 gg-pt-9 xl:gg-px-9">
            <SidebarProductsList products={cart.products} />
          </div>
        ) : (
          <></>
        )}
        {cart.standardProducts.length ? (
          <div className="gg-px-5 gg-pb-7 gg-pt-9 xl:gg-px-9">
            <CheckoutSidebarPanelList />
          </div>
        ) : (
          <></>
        )}

        <div className="gg-border-t gg-px-5 gg-py-7 xl:gg-pl-9 xl:gg-pr-5">
          {isSampleSale ? (
            <SampleSaleDoorPriceTable cart={cart} className="gg-mb-5" />
          ) : (
            <StandardProductPriceTable
              context={cartContext}
              entity={cart}
              className="gg-mb-5"
            />
          )}

          <div className="gg-col-span-12 gg-grid gg-w-full gg-grid-cols-12 gg-pt-2">
            <ProductItemExtra
              entity={cart}
              className="gg-col-span-12 gg-text-dark-blue-700 xl:gg-col-span-8"
            />
            <ProductsTotal
              entity={cart}
              context={cartContext}
              className={classNames({
                "gg-col-span-12 gg-justify-self-end xl:gg-col-span-12":
                  !isSampleSale,
                "gg-col-span-12 xl:gg-col-span-12": isSampleSale,
              })}
              isSampleSale={isSampleSale}
              isBusiness={cartContext.containsZakelijkProducts}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default CheckoutSidebarProducts;
